import { OuterContentContainer } from "@themes/pollinator/ui/OuterContentContainer";
import { SectionHeading } from "@themes/pollinator/ui/SectionHeading";
import { Type } from "@themes/pollinator/ui/Type";
import { ProgramPhaseActionItemContainer } from "@platform/features/programPhases";
import { isActionDisabledByDate, type Action } from "@core/features/actions";

export type Props = {
  surveyActions: Action[];
};

/**
 * Presentational component for the Surveys tab.
 * Renders survey actions as an action list.
 */
export function SurveysTabContent({ surveyActions }: Props) {
  return (
    <OuterContentContainer className="flex flex-1" innerClassName="gap-8">
      <div className="flex flex-col gap-8 max-w-3xl w-full">
        <SectionHeading
          title="Surveys"
          description="Complete surveys about your peer circle meetings."
        >
          {surveyActions.length === 0 ? (
            <Type variant="caption" className="text-brand-400">
              No surveys available yet.
            </Type>
          ) : (
            <div className="flex flex-col gap-3 max-w-lg">
              {surveyActions.map((action) => (
                <ProgramPhaseActionItemContainer
                  key={action.id}
                  action={action}
                  disabled={isActionDisabledByDate(action)}
                />
              ))}
            </div>
          )}
        </SectionHeading>
      </div>
    </OuterContentContainer>
  );
}

export default SurveysTabContent;
